import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-[#f2ebe1]" data-id="element-69">
      <div className="max-w-2xl mx-auto text-center" data-id="element-70">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6" data-id="element-71">
          <Shield className="w-8 h-8 text-brand-text" data-id="element-72" />
        </div>

        <h2 className="text-2xl md:text-3xl font-black text-brand-text mb-6 uppercase tracking-wide" data-id="element-73">
          RIPRENDITI IL TUO TEMPO, O TI RIMBORSIAMO
        </h2>

        <p className="text-brand-gray mb-6 leading-relaxed" data-id="element-74">
          14 giorni di garanzia soddisfatti o rimborsati, senza domande. Se non
          è ciò che ti aspettavi, ti restituiamo l'intero importo. Ci scrivi
          un'email e il rischio è zero.
        </p>

        <a href="#" className="text-sm font-bold text-brand-text underline underline-offset-4 hover:text-brand-green transition-colors" data-id="element-75">
          Leggi la politica di rimborso completa
        </a>
      </div>
    </section>;
}